import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { t } = useI18n();
  const [state, setState] = useState({ phase: "polling", data: null });
  const attemptsRef = useRef(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState({ phase: "failed", data: null }); return; }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      attemptsRef.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setState({ phase: "success", data });
          return;
        }
        if (attemptsRef.current >= 10) { setState({ phase: "failed", data }); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attemptsRef.current >= 10) { setState({ phase: "failed", data: null }); return; }
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { stop = true; };
  }, [params]);

  const p = state.phase;
  return (
    <div data-testid="payment-success-page" className="pt-32 pb-16 max-w-lg mx-auto px-6 text-center">
      {p === "polling" && (
        <>
          <Loader2 size={44} className="mx-auto text-[#143122] animate-spin" strokeWidth={1.5} />
          <h1 className="mt-6 font-serif-display text-3xl text-[#143122]">{t("payment_checking")}</h1>
          <p className="mt-3 text-sm text-[#1A1F1C]/70">{t("payment_checking_sub")}</p>
        </>
      )}
      {p === "success" && (
        <>
          <CheckCircle2 size={44} className="mx-auto text-[#143122]" strokeWidth={1.5} />
          <h1 className="mt-6 font-serif-display text-3xl text-[#143122]">{t("payment_success_title")}</h1>
          <p className="mt-3 text-sm text-[#1A1F1C]/70">{t("payment_success_sub")}</p>
          {state.data?.listing_id && (
            <Link
              to={`/listings/${state.data.listing_id}`}
              className="mt-6 inline-block kav-btn-primary text-sm"
              data-testid="payment-success-view-listing"
            >
              {t("view_listing")}
            </Link>
          )}
        </>
      )}
      {p === "failed" && (
        <>
          <XCircle size={44} className="mx-auto text-[#7A2A2A]" strokeWidth={1.5} />
          <h1 className="mt-6 font-serif-display text-3xl text-[#143122]">{t("payment_pending_title")}</h1>
          <p className="mt-3 text-sm text-[#1A1F1C]/70">{t("payment_pending_sub")}</p>
          <Link to="/dashboard" className="mt-6 inline-block text-[#143122] underline">
            {t("nav_dashboard")}
          </Link>
        </>
      )}
    </div>
  );
}
